export default (platform_plan_id, callback) => {
  const services = [
    "call_ai",
    "call_support",
    "message_sms",
    "message_line",
    "message_line_chat",
    "subkarte_ai_summary",
    "subkarte_dental_formulas_voice_input"
  ]
  const commonFields = ["use_option", "basic_price", "excessive_unit_price", "free_limit"]

  if (!platform_plan_id) {
    Array.from(document.getElementsByClassName("basic_price")).forEach(element => {
      element.value = ""
    })
    services.forEach(service => {
      clearServiceFields(service, commonFields)
    })
    if (callback) callback()
    return
  }

  const token = getCsrfToken()

  const xhr = new XMLHttpRequest()
  xhr.open('GET', '/api/v1/platform_plans/' + platform_plan_id)
  xhr.setRequestHeader('X-CSRF-Token', token)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send()
  xhr.addEventListener('load', function(result) {
    const response = result.currentTarget.responseText

    if (result.currentTarget.status !== 200) {
      alert(response)
      return
    }

    if (response.length === 0) {
      alert('プランマスタデータが取得できませんでした')
      return
    }

    const json = JSON.parse(response)

    Array.from(document.getElementsByClassName("basic_price")).forEach(element => {
      element.value = json.basic_price
    })

    services.forEach(service => {
      applyServiceFields(json, service, commonFields)
    })

    if (callback) callback()

  })

}

function applyJsonToFields(jsonPart, map) {
  Object.keys(map).forEach(key => {
    const defaultValue = key === "use_option" ? false : ""
    const value = jsonPart ? jsonPart[key] : defaultValue
    const elements = document.getElementsByClassName(map[key])
    Array.from(elements).forEach(el => {
      el.value = value !== undefined ? value : defaultValue
    })
  })
}

function applyServiceFields(json, serviceType, fields) {
  const fieldMap = {}
  fields.forEach(field => {
    fieldMap[field] = `${serviceType}_${field}`
  })
  applyJsonToFields(json[serviceType], fieldMap)
}

function clearServiceFields(serviceType, fields) {
  fields.forEach(field => {
    const value = field === "use_option" ? false : ""

    const className = `${serviceType}_${field}`
    const elements = document.getElementsByClassName(className)
    Array.from(elements).forEach(el => {
      el.value = value
    })
  })
}

function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ""
}
